import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import DiamondShapeIcon from "@public/images/dashcam/DiamondShape.svg";
import LineVectorIcon from "@public/images/dashcam/linevector.svg";
import LineVectorRight from "@public/images/dashcam/lineVectorRight.svg";
import DiamondShapeRight from "@public/images/dashcam/DiamondShapeRight.svg";
import {
  PlanHeadingContainer,
  HeadingText
} from "./styles";

export interface IPlanHeading extends CommonProps {
  text?: string;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const PlanHeading = (props: IPlanHeading) => {
  const { is_visible, text = "DASHCAM INSURANCE PLAN", styles, id } = props;

  return (id && is_visible) || !id ? (
    <PlanHeadingContainer styles={styles}>
      <LineVectorIcon />
      <DiamondShapeIcon />
      <HeadingText>{text}</HeadingText>
      <DiamondShapeRight />
      <LineVectorRight />
    </PlanHeadingContainer>
  ) : null;
};

export default connect(mapStateToProps)(PlanHeading);
